module.exports = __webpack_public_path__ + "static/teresita-de-la-torre-3-403a70e8af227c9d2b5a9f98837a8524.jpg";